type SecondFactorLike = ReadonlyArray<{ strategy: string }> | null | undefined;

export type EmailCodeAuthStep = 'email' | 'email_code' | 'totp' | 'mfa_email_code';

export function resolveEmailCodeAuthStep(
  status: string,
  supportedSecondFactors: SecondFactorLike,
): EmailCodeAuthStep | null {
  if (status === 'needs_identifier' || status === 'needs_first_factor') {
    return 'email';
  }
  if (status === 'needs_second_factor') {
    if (supportedSecondFactors?.some((factor) => factor.strategy === 'totp')) {
      return 'totp';
    }
    if (supportedSecondFactors?.some((factor) => factor.strategy === 'email_code')) {
      return 'mfa_email_code';
    }
  }
  return null;
}
